(function () {
    var maxMobileDeviceWidth = 767;

    /**
     * Enhancements for header nav.
     */
    function enhanceHeader() {
        scrollyNav();

        window.addEventListener('scroll', scrollyNav);
    }

    function scrollyNav() {
        var header = document.getElementById('header');
        if (!header) return;

        var headerHeight = header.offsetHeight;

        if (window.scrollY > headerHeight * 0.9) {
            header.classList.add('header-scroll');
        } else {
            header.classList.remove('header-scroll');
        }
    }

    /**
     * Enhance any anchor navigation elements on the page.
     */
    function enhanceAnchors() {
        if (
            window.location.pathname !== '/' &&
            window.location.pathname !== '/fr/'
        ) {
            return;
        }

        var anchors = document.querySelectorAll('a[href^="#"]');

        anchors.forEach(function (anchor) {
            anchor.addEventListener('click', function (event) {
                var hash = this.getAttribute('href');
                var target = document.querySelector(hash) ||
                             document.querySelector('[name="' + hash.slice(1) + '"]');

                if (target) {
                    event.preventDefault();

                    var headerWrap = document.querySelector('.header-nav-wrap');
                    var offset = headerWrap ? headerWrap.offsetHeight : 0;

                    var targetPosition =
                        target.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    /**
     * Enhance the portfolio to add some visual fun.
     */
    function enhancePortfolio() {
        if (window.innerWidth > maxMobileDeviceWidth) {
            var links = document.querySelectorAll('.portfolio-gallery a');

            links.forEach(function (el) {
                var a = Math.random() * 10 - 6;
                el.style.transform =
                    'translate(-50%, -50%) rotate(' + a + 'deg) scale(1.25)';
            });
        }
    }

    /**
     * Attach event listeners
     */
    document.addEventListener('DOMContentLoaded', function () {
        enhanceHeader();
        enhanceAnchors();
        enhancePortfolio();
    });
})();
